export class dbh_numberFormatChangeDE {
    private static submitHandler: ((e: Event) => void) | null = null;
    private static setupCount: number = 0;  // Zähler für Initialisierungen

    // Hilfsfunktion: Zahl formatieren (DE)
    public formatNumberDE(value: string): string {
        // Nur formatieren, wenn es eine gültige DE-Zahl ist
        if (!this.isNumeric(value)) return value;

        // Vorverarbeitung: Entferne Tausenderpunkte, ersetze Komma durch Punkt
        const normalized = value.replace(/\./g, '').replace(',', '.');
        const num = parseFloat(normalized);

        if (isNaN(num)) return value;
        
        // Nachkommastellen zählen
        const decimalMatch = value.match(/,(\d+)$/);
        const decimalPlaces = decimalMatch ? decimalMatch[1].length : 0;
        
        // Zahl im deutschen Format ausgeben
        return num.toLocaleString('de-DE', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });
    }

    // Hilfsfunktion: Formatierung entfernen  
    public unformatNumberDE(value: string): string {
        return value.replace(/\./g, '').replace(',', '.');
    }

    // Prüft, ob ein String eine gültige DE-Zahl ist (z.B. 1.234,56 oder 123,45 oder 1234)
    public isNumeric(value: string): boolean {
        // ^-?         : optionales Minus am Anfang
        // \d{1,3}     : 1-3 Ziffern am Anfang
        // (\.\d{3})*  : beliebig viele Tausendergruppen mit Punkt
        // (,\d+)?     : optionale Nachkommastellen mit Komma
        // $           : Ende
        // ODER: ^-?\d+(,\d+)?$ für Zahlen ohne Tausenderpunkt
        //console.log(value + " - " + /^-?(\d{1,3}(\.\d{3})+|\d+)(,\d+)?$/.test(value.trim()));
        return /^-?(\d{1,3}(\.\d{3})+|\d+)(,\d*)?$/.test(value.trim());
    }

    // Formatiert alle Zahlen im angegebenen Container  
    public formatNumbersInContainer(container: HTMLElement) {
        // Alle Inputs und alle anderen Elemente, außer mit der Klasse 'no-format'  
        const elements = container.querySelectorAll<HTMLElement>(
            'input:not(.no-auto-number-format), span:not(.no-auto-number-format), div:not(.no-auto-number-format), a:not(.no-auto-number-format), td:not(.no-auto-number-format), th:not(.no-auto-number-format), p:not(.no-auto-number-format)'
        );
        elements.forEach(el => {
            if (el instanceof HTMLInputElement) {
                el.value = this.formatNumberDE(el.value);
            } else {
                const text = el.textContent || '';
                if (this.isNumeric(text)) {
                    el.textContent = this.formatNumberDE(text);
                }
            }
        });
    }

    // Vor dem Absenden: Nur Inputs zurücksetzen  
    public unformatAllNumberInputs(form: HTMLFormElement) {
        // Nur Inputs innerhalb von data-format-number, ohne die Klasse 'no-format'
        const containers = form.querySelectorAll<HTMLElement>('[data-format-number]');
        containers.forEach(container => {
            const inputs = container.querySelectorAll<HTMLInputElement>('input:not(.no-auto-number-format)');
            inputs.forEach(input => {
                // Prüfe, ob das Input bereits verarbeitet wurde
                if (input.dataset.unformatted === "true") {
                    return; // Überspringen, wenn schon verarbeitet
                }
               
                input.value = this.unformatNumberDE(input.value);
                input.dataset.unformatted = "true"; // Markiere als verarbeitet
            });
        });
    }

    // Initialisierung: Event-Handler setzen  
    public setupNumberFormatting() {
        console.log(`Setup called ${++dbh_numberFormatChangeDE.setupCount} times`);

        // Submit-Handler nur einmal registrieren
        if (!dbh_numberFormatChangeDE.submitHandler) {

            // Initial alle Container formatieren  
            document.querySelectorAll<HTMLElement>('[data-format-number]').forEach(container => {
                this.formatNumbersInContainer(container);
            });

            // Bei Eingabe formatieren (nur Inputs innerhalb von data-format-number)  
            document.addEventListener('input', (e) => {
                const target = e.target as HTMLInputElement;
                if (
                    target &&
                    target instanceof HTMLInputElement &&
                    !target.classList.contains('no-auto-number-format') &&
                    target.closest('[data-format-number]')
                ) {
                    const originalValue = target.value;
                    const originalCursorPos = target.selectionStart || 0;

                    // Wenn der letzte eingegebene Charakter ein Komma ist, und es ist das erste Komma,
                    // dann behalten wir es bei, um die Eingabe zu ermöglichen.
                    const endsWithComma = originalValue.endsWith(',') && (originalValue.match(/,/g) || []).length === 1;

                    const formattedValue = this.formatNumberDE(originalValue);
                    target.value = formattedValue;

                    // Wenn der Wert mit einem Komma endete, fügen wir es wieder an,
                    // da formatNumberDE es entfernen könnte.
                    if (endsWithComma && !target.value.includes(',')) {
                        target.value += ',';
                    }

                    // Berechne die neue Cursor-Position
                    const newLength = target.value.length;
                    const oldLength = originalValue.length;
                    let newCursorPos = originalCursorPos + (newLength - oldLength);

                    // Korrigiere die Cursor-Position, wenn sie ungültig wird
                    if (newCursorPos < 0) {
                        newCursorPos = 0;
                    } else if (newCursorPos > newLength) {
                        newCursorPos = newLength;
                    }

                    target.setSelectionRange(newCursorPos, newCursorPos);
                }
            });

            dbh_numberFormatChangeDE.submitHandler = (e: Event) => {                
                const form = e.target as HTMLFormElement;
                if (form) {
                    this.unformatAllNumberInputs(form);
                }
            };
            document.addEventListener('submit', dbh_numberFormatChangeDE.submitHandler);
        } else {
            console.log('Submit handler already exists');
        }
    }

    // Konstruktor ruft die Initialisierung auf  
    constructor() {
        this.setupNumberFormatting();
    }
}